<template>
    <button
        :class="{ 'invisible': isDisabled }"
        type="button"
        class="text-sm font-bold tracking-normal"
    >
        <span class="text-green font-black">
            &check;
        </span>
        <span class="underline">
            {{ $t('APPLY') }}
        </span>
    </button>
</template>

<script>
    import allStores from '../stores/all';

    export default {
        mixins: [allStores],

        props: {
            groupName: {
                type: String,
                default: '',
            },
        },

        computed: {
            selectionWasMade() {
                return this.customizerStore.selectionsMade.includes(this.groupName);
            },

            disableEdit() {
                return this.customizerStore.disableEdit;
            },

            isDisabled() {
                return !this.selectionWasMade || (this.groupName !== 'Size & Width' && this.disableEdit);
            },
        },
    };
</script>
